/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Externaldepartmentdepartment2Inputs */

const en__field_externaldepartmentdepartment2 = /** @type {(inputs: _Field_Externaldepartmentdepartment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`External: Department`)
};

const de__field_externaldepartmentdepartment2 = /** @type {(inputs: _Field_Externaldepartmentdepartment2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extern: Fachbereich`)
};

/**
* | output |
* | --- |
* | "External: Department" |
*
* @param {_Field_Externaldepartmentdepartment2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_externaldepartmentdepartment2 = /** @type {((inputs?: _Field_Externaldepartmentdepartment2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Externaldepartmentdepartment2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_externaldepartmentdepartment2(inputs)
	return de__field_externaldepartmentdepartment2(inputs)
});
export { _field_externaldepartmentdepartment2 as "_field_externalDepartmentDepartment" }